import {
  convertSegfilterSegmentationToPropertySegmentation,
  convertSegfilterToPropertyFilter,
} from 'common/widgets/property-filter-menu/models/segfilter';
import {CompleteSegfilter} from 'common/report/funnels/models/types';

/**
 * Converts groupBySelectedCohorts data into FunnelsQuery params
 * @param {Number[]} groupBySelectedCohorts cohort ids
 * @return FunnelsQuery params
 */
export function paramsFromGroupBySelectedCohorts(groupBySelectedCohorts: number[] = []) {
  const params = {
    groupByCohorts: [],
    groupBy: [],
  };
  if (groupBySelectedCohorts && groupBySelectedCohorts.length > 0) {
    const cohorts = groupBySelectedCohorts.flatMap((id) => [{id, negated: false}]);
    params.groupBy.push(cohorts.map((cohort) => ({cohort})));
    params.groupByCohorts = cohorts;
  }
  return params;
}

/**
 * Converts segfilter data into FunnelsQuery params
 * @param {CompleteSegfilter} segfilter
 * @return FunnelsQuery params
 */
export function paramsFromSegfilter(segfilter: CompleteSegfilter = null) {
  const params = {
    eventFilters: [],
    groupBy: [],
    userFilters: [],
  };
  if (segfilter && segfilter.filters.length > 0) {
    const numCombined = segfilter.filters.length;
    const numSeg = Object.prototype.hasOwnProperty.call(segfilter.filters[numCombined - 1], `filter`) ? 0 : 1;
    const segfilterFilters = segfilter.filters.slice(0, numCombined - numSeg);
    const segfilterSegment = segfilter.filters.slice(numCombined - numSeg, numCombined);
    if (segfilterFilters.length) {
      const propertyFilters = segfilterFilters.map(
        (filter) => `filter` in filter && convertSegfilterToPropertyFilter(filter),
      );
      params.eventFilters = propertyFilters.filter((filter) => filter.resourceType === `event`);
      params.userFilters = propertyFilters.filter((filter) => filter.resourceType === `user`);
    }
    if (segfilterSegment.length) {
      params.groupBy = segfilterSegment.map((segment) => {
        const segmentItem = convertSegfilterSegmentationToPropertySegmentation(segment);
        return {[segmentItem.resourceType]: segmentItem};
      });
    }
  }
  return params;
}
